<form
	[formGroup]="addressForm"
	class="addressForm"
>

	<triv-input [fGroup]="addressForm" [data]="myInputs.ansStrasse" />
	<triv-input [fGroup]="addressForm" [data]="myInputs.ansHausnummer" />
	<triv-input [fGroup]="addressForm" [data]="myInputs.ansPlz" />
	<triv-input [fGroup]="addressForm" [data]="myInputs.ansOrt" />
	

	<button
		mat-raised-button
		[disabled]="!addressForm.valid || bInProgress"
		(click)="clickUpdateAddress()"
	>
		Speichern
	</button>

	<div class="errorWarning" style="text-align: center;">
		{{errorMsg}}
	</div>


</form>
